import { PlusIcon } from "lucide-react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

import { Button } from "@/components/ui/button/button";
import { useQuery } from "@tanstack/react-query";
import { getAllAdminsQueryOptions } from "@/config/queries/superadmin-query-options";
import { useMemo } from "react";
import { DataTable } from "./_components/admins-table/data-table";
import { columns } from "./_components/admins-table/columns";

const AllAdminsPageOfSuperAdmin = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching } = useQuery(
    getAllAdminsQueryOptions(user)
  );

  const adminsData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.admins === undefined) {
      return [];
    }

    const result = data?.admins?.map((emp) => {
      return {
        id: emp?._id,
        name: emp?.name,
        email: emp?.email,
        phone: emp?.phone,
        // blocked: emp?.blocked,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Admins</h3>

        <Button className="flex items-center gap-1" asChild>
          <Link to="/superadmin/admins/new">
            <PlusIcon />
            <span>New Admin</span>
          </Link>
        </Button>
      </div>

      {isPending ? (
        <div>Loading</div>
      ) : data?.admins?.length ? (
        <div className="mt-5">
          <DataTable data={adminsData} columns={columns} />
        </div>
      ) : (
        <div>No Admin</div>
      )}
    </div>
  );
};

export default AllAdminsPageOfSuperAdmin;
